import React from "react";

export const CloseSVG = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="23.359" height="23.282" viewBox="0 0 23.359 23.282">
        <path fill="white" id="close" d="M23.359,5.7,13.984,15l9.375,9.3-2.344,2.344-9.375-9.3-9.3,9.3L0,24.3,9.3,15,0,5.7,2.344,3.359l9.3,9.3,9.375-9.3Z" transform="translate(0 -3.359)"/>
    </svg>
)